import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeContainerTypeListItem extends SearchModelBase {
    containerType: string = '';
    isoType: string = '';
    containerGroup: string = '';
    description: string = '';
    length: string = '';
    height: string = '';
    relatedType: string = '';
    inactive: boolean = false;
    inactiveDate: string | null = null;
    inactiveBy: string = '';
    u2Date: string | null = null;
    updatedBy: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Container Type', width: 150, dataIndex: 'containerType'}),
        XCol.Create({ col: 1, text: 'Description', width: 150, dataIndex: 'description'}),
        XCol.Create({ col: 2, text: 'Group', width: 150, dataIndex: 'containerGroup'}),
        XCol.Create({ col: 3, text: 'ISO Type', width: 150, dataIndex: 'isoType'}),
        XCol.Create({ col: 4, text: 'Length', width: 150, dataIndex: 'length'}),
        XCol.Create({ col: 5, text: 'Height', width: 150, dataIndex: 'height'}),
        XCol.Create({ col: 6, text: 'Type', width: 150, dataIndex: 'relatedType: '}),
        XCol.Create({ col: 7, text: 'Inactive', width: 150, dataIndex: 'inactive'}),
        XCol.Create({ col: 8, text: 'Inactive Date', width: 150, dataIndex: 'inactiveDate'}),
        XCol.Create({ col: 9, text: 'Update Date', width: 150, dataIndex: 'updatedBy'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeContainerTypeListItem.prototype.containerType, orderByAscending: false };

    public static formatData(data: CodeContainerTypeListItem[]) {
        return data.map((d: CodeContainerTypeListItem) => ({
          ...d,
        }));
    }

}
